import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'tailwindcss/tailwind.css';
import ReactPlayer from 'react-player';
import { i18n } from './i18n';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

const Camera = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);

  const { i18n } = useTranslation();
  useEffect(() => {
    const savedLanguage = Cookies.get('language') || 'en';
    i18n.changeLanguage(savedLanguage);
    AOS.init({ duration: 100 });
  }, []);

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const handlePlaybackRateChange = (rate) => {
    setPlaybackRate(rate);
  };

  const { t } = useTranslation();
  return (
    <div className="px-10 flex flex-col items-center justify-center min-h-8">
      <div className="w-full max-w-6xl p-2 mx-auto lg:p-6">
        <div className="flex flex-col items-center justify-between md:flex-row gap-4"> {/* 16px gap only in desktop view */}

          {/* Video Section */}
          <div className="relative w-full h-48 md:w-1/2 md:h-96 lg:h-168"
            data-aos="zoom-in-right"
            data-aos-easing="ease-out-cubic"
            style={{ maxWidth: '500px' }}> {/* Max width ensures alignment */}
            <ReactPlayer
              url="https://res.cloudinary.com/dppxkpqwh/video/upload/v1744029308/Shani_Mandir_Updated_video_dmznop.mp4" // Update video URL
              playing={isPlaying}
              playbackRate={playbackRate}
              controls={true}
              muted={true}
              width="100%"
              height="100%"
              className="absolute top-0 left-0 w-full"
            />
          </div>

          {/* Info Section */}
          <div className="w-full md:w-1/2 md:pt-8"
            data-aos="fade-left"
            style={{ maxWidth: '500px' }}> {/* Max width ensures alignment */}
            <h2 className="mb-4 font-bold text-xl 2xl:text-xl">
              {t('Book')}
            </h2>
            <p className="mb-4 text-gray-700 text-xs sm:text-sm lg:text-base text-justify">
              {t('SSF')}
            </p>
            <div className="flex flex-col items-center gap-2 md:flex-row md:justify-start">
  <a
    href="https://forms.gle/MUaxKwQ6eVoFFoh88"
    target="_blank"
    rel="noopener noreferrer"
    className="px-2 py-1 text-sm text-white bg-red-600 rounded-md lg:px-4 lg:py-2 lg:text-base hover:bg-red-700"
  >
    {t('Booking')}
  </a>

  <a
    href="https://drive.google.com/file/d/1YO5hSnaZBuBf5Eas73RxOpNPoLxkty9a/view?usp=sharing" // Replace with actual PDF URL
    target="_blank"
    rel="noopener noreferrer"
    className="px-2 py-1 text-sm text-white bg-indigo-600 rounded-md lg:px-4 lg:py-2 lg:text-base hover:bg-indigo-700"
  >
     {t('Invitation')}
  </a>
</div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Camera;
